//import packages from node modules
import React,{useState,useEffect,useRef,useCallback} from 'react'
import PropTypes from 'prop-types'
import {useDispatch} from 'react-redux'
import {withRouter} from 'react-router-dom'

//import utility functions
import globalCookies from '../../../../utilities/function/cookies'

//import shared components
import Heading from "../../../shared/typography/heading"
import Description from "../../../shared/typography/description"
import SwitchForm from "./SwitchForm"
import SwitchFinished from "./SwitchFinished"
import Loading from "../../../shared/loading"
import {Login} from "../../../pages/checkout/account"
import CheckoutHeader from "../../../pages/checkout/header"
import SWITCH_API,{cancelSubmitSwitchForm} from  "../../../../utilities/api/switch"
import ACCOUNT_API from "../../../../utilities/api/account"

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from "../../../../utilities/function/apiResponse"

import {
  getDataFromURL
} from "../../../../utilities/function/urlparams"

import {getAppConfigValue} from "../../../../utilities/function/configuration"
import {updatePopupNotification} from "../../../../app/action"
import {useAccount} from "../../../../utilities/function/checkout"

let Switch = (props) => {
  const  dispatch = useDispatch()
  const {location,history} = props
  const {a,step} = getDataFromURL(location.search)
  const textContent = {
      "select-service": {
        heading: "Your curent service details",
        description: "Tell us about where you're coming from"
    },
    "default": {
      heading: "Tell us a bit about yourself",
      description: "We'll start by getting to know you"
    }
  }
  const renderHeadingDescription = () => {
    const renderTexts = (key) =>{
      const content = textContent[key]
      if(content){
        return (
          <>
            {content.heading?<Heading className={`of-switch-heading text-font-1-100`}>{content.heading}</Heading>:<></>}
            {content.description?<Description className={`of-switch-description text-font-3-100`}>{content.description}</Description>:<></>}
          </>
        )
      }
      return(<></>)
    }
    if(step){
      return (renderTexts(step))
    }
    return (renderTexts("default"))
  }
  const [requestSubmitSwitchForm,setRequestSubmitSwitchForm] = useState({})
  const [checkToken,setCheckToken] = useState({})
  const handleSubmitSwitchForm = (attributes) =>{
    const handleSubmitPersonalDetails = () => {
      if(attributes){
        try{
          const stringAttributes = JSON.stringify(attributes)
          localStorage.setItem('SwitchForm',stringAttributes)
        }catch (e) {}
      }
      history.push(`${history.location.pathname}?a=switch&step=select-service`)
    }
    const handleSubmitServiceDetails = (attributes) => {
      if(cancelSubmitSwitchForm){
        cancelSubmitSwitchForm()
      }

      const getPayload = () => {
        if(attributes){
          const {domain_name,email,first_name,last_name,other_provider,provider,remaining_time} = attributes
          const payload = {
            domain_name,
            email,
            first_name,
            last_name,
            remaining_time,
            provider: provider==='Other'? other_provider: provider
          }
          return payload
        }
        return null
      }

      setRequestSubmitSwitchForm({
        ...requestSubmitSwitchForm,
        status: 'loading'
      })
      SWITCH_API.submitForm(getPayload()).then((successResponse)=>{
        const data = getDataFromSuccessResponse(successResponse)
        localStorage.removeItem('SwitchForm')
        setRequestSubmitSwitchForm({
          ...requestSubmitSwitchForm,
          status: 'success',
          data
        })
        history.push(`${history.location.pathname}?a=switch&step=finished`)
      },(errorResponse)=>{
        const error = getErrorFromFailResponse(errorResponse)
        updatePopupNotification(dispatch,{
          status:'error',
          error
        })
        setRequestSubmitSwitchForm({
          ...requestSubmitSwitchForm,
          status: 'error',
          error
        })
      })
    }
    if(step==="select-service"){
      return handleSubmitServiceDetails(attributes)
    }
    return handleSubmitPersonalDetails(attributes)
  }
  const {initAccount,renderBillingInfo} = useAccount(checkToken)
  const prevStep = useRef(false)
  const changeStepCallback = useCallback(()=>{
    const handleFinishedPage =() => {
      //redirect to initial page when user reload the finished page
      if(requestSubmitSwitchForm.status !== "success"){
        history.push(`${history.location.pathname}?a=switch`)
      }
    }
    if (prevStep.current !== step){
      const requestCheckToken = () => {
        const access_token = globalCookies.get('access_token')
        if (access_token) {
          setCheckToken({
            ...checkToken,
            status: "loading"
          })
          ACCOUNT_API.checkToken(access_token).then(successResponse => {
            const data = getDataFromSuccessResponse(successResponse)
            history.push(`${history.location.pathname}?a=switch&step=select-service`)
            setCheckToken({
              ...checkToken,
              status: "success",
              data
            })
          }, errorResponse => {
            const error = getErrorFromFailResponse(errorResponse)
            setCheckToken({
              ...checkToken,
              status: "error",
              error
            })
          })
        }
      }
      if(step) {
        switch (step) {
          case 'finished':
            handleFinishedPage()
            break;
          default:
            requestCheckToken()
            break;
        }
      }else{
        requestCheckToken()
      }
      prevStep.current = step;
    }
  },[prevStep,requestSubmitSwitchForm,history,step,checkToken])
  useEffect(()=>{
    initAccount(false)
    changeStepCallback()
  },[changeStepCallback,initAccount])

  const renderLoading = () => {
    if(requestSubmitSwitchForm.status==="loading" || checkToken.status ==="loading"){
      return (
        <Loading wrapper={true} className={'of-switch-loading'}/>

      )
    }
    return (<></>)
  }
  const renderLoginBox = () => {
    const company_name = getAppConfigValue('company_name')
    const ccp_link = getAppConfigValue('ccp_link')
    const ccp_name = getAppConfigValue('ccp_name')
    const ctaLinkOnClick = (e) =>{
      e.preventDefault()
      history.push(`${history.location.pathname}?a=switch&step=login`)
    }
    if(!step){
      return (
        <div className={'of-switch-login-cta'}>
          <div className={'of-switch-login-cta__or'}>
            <div className={'border lines-background-1-100 text-font-1-100'}/>
            <span>OR</span>
          </div>
          <div className={'of-switch-login-cta__box shades-primary-background-1-100'} onClick={ctaLinkOnClick}>
            <div className={'of-switch-login-cta__box-wrapper text-font-1-100'}>
              Already a {company_name} Customer? <span className={`of-switch-login-cta__link primary-font-1-100`} href={ccp_link} target={'_blank'}>Login to {ccp_name}</span>
            </div>
          </div>
        </div>
      )
    }
    return (<></>)
  }
  const renderMain = () => {
    switch (step){
      case 'finished':
        return ( <SwitchFinished {...requestSubmitSwitchForm}/>)
      case 'login':
        return (<Login checkToken={checkToken}
                       redirectURL={'?a=switch&step=select-service'}
                       accountURL={'?a=switch&step=login'}
                       gobackURL = {'?a=switch'}
          />
        )
      default:
        return (
          <>
            {renderBillingInfo(false)}
            <SwitchForm checkToken={checkToken} step={step} onSubmit={handleSubmitSwitchForm}/>
            {renderLoginBox()}
          </>
        )
    }
  }


  if(a==="switch"){
    return(<>
      <CheckoutHeader checkToken={checkToken}/>
      <div className={`of-switch of-checkout-content${requestSubmitSwitchForm.status==="loading"? " of-switch--loading":""}`}>
      <div className={'of-switch__wrapper'}>
        {renderHeadingDescription()}
        {renderMain()}

      </div>
    </div> {renderLoading()}</>)
  }
  return (<></>)
}
Switch.propTypes= {
  location : PropTypes.object,
  history: PropTypes.object
}

Switch = withRouter(Switch)

export default Switch